<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">姓名：</span>
        </div>
        <el-input v-model="formData.personName" :maxlength="24" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">性别：</span>
        </div>
        <div style="display: inline-block">
          <el-radio-group v-model="formData.sex" style="width: 280px" size="small">
            <el-radio-button label="0">男</el-radio-button>
            <el-radio-button label="1">女</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">手机号：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" :maxlength="11" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">身份证号：</span>
        </div>
        <el-input v-model="formData.identityNumber" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">申请房型：</span>
        </div>
        <el-select v-model="formData.rentType" placeholder="请选择" size="mini" style="width: 280px">
          <el-option v-for="item in rentTypeList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预入住日期：</span>
        </div>
        <el-date-picker v-model="formData.stayStartTime" type="date" size="small" style="width: 280px" :editable=false value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预租期限：</span>
        </div>
        <el-select v-model="formData.leaseTimeLimit" placeholder="请选择" size="mini" style="width: 280px">
          <el-option v-for="item in leaseTimeLimitList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.remarks" size="small" style="width: 280px" />
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import InputDatePicker from '../../../components/Input/InputDatePicker'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/LeaseManage'
  import {nError, nSuccess} from '../../../utils/notice'
  import {pattern} from '../../../utils/regular'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      InputDatePicker,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'lessee-modify',
    data () {
      return {
        yqCode: '',
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '人员管理'
        }],
        mainTitle: '修改人员',
        subheading: '',
        nationList: [
          {label: '汉族', value: '汉族'},
          {label: '壮族', value: '壮族'},
          {label: '藏族', value: '藏族'},
          {label: '裕固族', value: '裕固族'},
          {label: '彝族', value: '彝族'},
          {label: '瑶族', value: '瑶族'},
          {label: '锡伯族', value: '锡伯族'},
          {label: '乌孜别克族', value: '乌孜别克族'},
          {label: '维吾尔族', value: '维吾尔族'},
          {label: '佤族', value: '佤族'},
          {label: '土家族', value: '土家族'},
          {label: '土族', value: '土族'},
          {label: '塔塔尔族', value: '塔塔尔族'},
          {label: '塔吉克族', value: '塔吉克族'},
          {label: '水族', value: '水族'},
          {label: '畲族', value: '畲族'},
          {label: '撒拉族', value: '撒拉族'},
          {label: '羌族', value: '羌族'},
          {label: '普米族', value: '普米族'},
          {label: '怒族', value: '怒族'},
          {label: '纳西族', value: '纳西族'},
          {label: '仫佬族', value: '仫佬族'},
          {label: '苗族', value: '苗族'},
          {label: '蒙古族', value: '蒙古族'},
          {label: '门巴族', value: '门巴族'},
          {label: '毛南族', value: '毛南族'},
          {label: '满族', value: '满族'},
          {label: '珞巴族', value: '珞巴族'},
          {label: '僳僳族', value: '僳僳族'},
          {label: '黎族', value: '黎族'},
          {label: '拉祜族', value: '拉祜族'},
          {label: '柯尔克孜族', value: '柯尔克孜族'},
          {label: '景颇族', value: '景颇族'},
          {label: '京族', value: '京族'},
          {label: '基诺族', value: '基诺族'},
          {label: '回族', value: '回族'},
          {label: '赫哲族', value: '赫哲族'},
          {label: '哈萨克族', value: '哈萨克族'},
          {label: '哈尼族', value: '哈尼族'},
          {label: '仡佬族', value: '仡佬族'},
          {label: '高山族', value: '高山族'},
          {label: '鄂温克族', value: '鄂温克族'},
          {label: '俄罗斯族', value: '俄罗斯族'},
          {label: '鄂伦春族', value: '鄂伦春族'},
          {label: '独龙族', value: '独龙族'},
          {label: '东乡族', value: '东乡族'},
          {label: '侗族', value: '侗族'},
          {label: '德昂族', value: '德昂族'},
          {label: '傣族', value: '傣族'},
          {label: '达斡尔族', value: '达斡尔族'},
          {label: '朝鲜族', value: '朝鲜族'},
          {label: '布依族', value: '布依族'},
          {label: '布朗族', value: '布朗族'},
          {label: '保安族', value: '保安族'},
          {label: '白族', value: '白族'},
          {label: '阿昌族', value: '阿昌族'},
          {label: '其他', value: '其他'}
        ],
        identityTypeList: [{
          label: '身份证',
          value: '身份证'
        }],
        rentTypeList: [
          {key: 0, label: '整租'},
          {key: 1, label: '床位'}
        ],
        leaseTimeLimitList: [
          {key: '一个月', label: '一个月'},
          {key: '三个月', label: '三个月'},
          {key: '半年', label: '半年'},
          {key: '一年', label: '一年'},
          {key: '一年以上', label: '一年以上'},
        ],
        formData: {
          personName: '',
          sex: '',
          phone: '',
          identityNumber: '',
          rentType: '',
          stayStartTime: '',
          leaseTimeLimit: '',
          remarks: ''
        },
        currentCode: ''
      }
    },
    created () {
      this.yqCode = bus.global.yqCode
      this.currentCode = this.$route.params.id
      this.getPersonLeaseByCode()
    },
    methods: {
      toPersonManagement () {
        this.$router.push({
          name: 'lessee-management'
        })
      },

      getPersonLeaseByCode () {
        this.$axios.get(`${api.getPersonLeaseByCode}/${this.currentCode}`, {})
          .then(res => {
            let data = res.data.data
            this.formData = data
          })
          .catch(errorHandler('查询人员失败'))
      },

      upImg () {
        $('#upload')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            const objUrl = getObjectURL(this.files[0]) // 获取图片的路径，该路径不是图片在本地的路径
            if (objUrl) {
              $('#peopleImg').attr('src', objUrl) // 将图片路径存入src中，显示出图片
              window.sessionStorage.setItem('img', objUrl)
            }
          })
      },
      upData () {
        const that = this
        const oFReader = new FileReader()
        const file = document.getElementById('upload').files[0]
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          $('#peopleImg').attr('src', src)
          that.formData.yqPicStr = src
        }
      },

      confirm () {
        let checkName = pattern.characterInput_24.test(this.formData.personName)
        let checkPhone = pattern.telephoneOrPhone.test(this.formData.phone)
        if (!this.formData.personName) {
          nError('请输入人员姓名')
          return false
        } else {
          if (!checkName) {
            nError('姓名不允许有特殊字符或空格')
            return false
          }
        }
        if (!this.formData.phone) {
          nError('请输入人员手机')
          return false
        } else {
          if (!checkPhone) {
            nError('手机格式不正确')
            return false
          }
        }
        if (!this.formData.identityNumber) {
          nError('请输入身份证号')
          return false
        }
        this.$axios.post(api.updatePersonLease, this.formData)
          .then(res => {
            nSuccess('修改成功')
            this.toPersonManagement()
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toPersonManagement()
      }
    },
    watch: {}
  }
  function getObjectURL (file) {
    let url = null
    if (window.createObjectURL !== undefined) { // basic
      url = window.createObjectURL(file)
    } else if (window.URL !== undefined) { // mozilla(firefox)
      url = window.URL.createObjectURL(file)
    } else if (window.webkitURL !== undefined) { // webkit or chrome
      url = window.webkitURL.createObjectURL(file)
    }
    return url
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
    position: relative;
  }
  form .photoBox {
    width: 120px;
    height: 160px;
    border: 1px dashed #dcdfe6;
    border-radius: 5px;
    position: absolute;
    left: 450px;
    top: 0;
  }
  .personExample {
    position: absolute;
    bottom: -30px;
    text-align: center;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #00a0e6;
    cursor: pointer;
  }
  .photoBox img {
    width: 100%;
    height: 100%;
  }
  .photoBox p {
    color: #999999;
    font-size: 12px;
    text-align: center;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 0 0 15px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/LesseeManage/LesseeModify.vue